<template>
    <div class="exhibition-wrapper"  v-loading="loading">
        <iframe ref="iframe" :src="src" style="width:100%;height:100%;border:0;min-width: 1400px;"></iframe>
        <CHeader :hideMenu="hideMenu" />
        <CFooter />
        <div class="liveBox" @click="goLive">
            <img  src="../../assets/zhibo.png" alt="" class="liveBox-img">
            <span class="liveBox-title">{{$t("exhibition").live}}</span>
        </div>
        <transition name="pavilion-show">
          <div class="show-pavilion" v-show="isPavilion">
              <div class="show-pavilion-content">
                  <div class="title">
                      <div class="line"></div>
                      <div class="title-name">正在举办</div>
                  </div>
                  <div class="item">
                      <ul>
                          <li class="item-wrap" v-for="(item, index) in holdingData" :key="index"  @click="goIsHolding(item.base_info.exhibition_id)">
                              <div class="item-name">{{ language == 'zh' ? item.base_info.data.cn && item.base_info.data.cn.name : item.base_info.data.en&&item.base_info.data.en.name || ''}}</div>
                              <div class="item-time">{{ (item.open_date).substring(5,10)}} ~ {{(item.close_date).substring(5,10)}}</div>
                          </li>
                      </ul>
                  </div>
              </div>
              <div class="hide-pavilion-content" @click="handleChangeIsPavilion">
                  <i class="el-icon-arrow-left arrow-icon"></i>
              </div>
          </div>
        </transition>
        <transition name="pavilion-hide">
          <div class="hide-pavilion" v-show="!isPavilion" @click="handleChangeIsPavilion">
              <i class="el-icon-arrow-right arrow-icon"></i>
          </div>
        </transition>
        <!-- 正在举办 -->
        <el-drawer
            :visible.sync="drawerIsHolding"
            :direction="directionIsHolding"
            :modal="false"
        >   
            <img src="../../assets/drawer_close.png" class="close-drawer" @click="handleCloseHolding">
            <el-tabs v-model="activeNameIsHolding" @tab-click="handleClick">
                <el-tab-pane :label="$t('exhibition.hold')" name="first">
                    <ul class="el-row">
                        <li class="el-col el-col-6 holding-item-wrap" v-for="(item, index) in holdingData" :key="index" @click="goExhibition(item.id)">
                            <div class="holding-item">
                                <div class="holding-img" v-if="item.main_img">
                                    <img :src="item.main_img && item.main_img.url" />
                                </div>
                                <div v-else>
                                    <!-- <img :src="logo" alt=""> -->
                                </div>
                                <div class="holding-content">
                                    <div style="color:#333;font-size: 14px;line-height: 20px;margin: 15px 0px 10px 20px">
                                       <span>{{$t("exhibition").start_time}}：</span>
                                       <span>{{ (item.open_date).substring(0,10)}} ~ {{(item.close_date).substring(0,10)}}</span>
                                    </div>
                                    <div style="color:#333;font-size: 14px;line-height: 20px;margin: 0px 0px 10px 20px">
                                       <span>{{$t("exhibition").place}}：</span>
                                       <span>{{ item.base_info.exh_address || '/'}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </el-tab-pane>
                <el-tab-pane :label="$t('exhibition.ready')" name="second">
                    <ul class="el-row">
                        <li class="el-col el-col-6 holding-item-wrap" v-for="(item, index) in endData" :key="index" @click="goExhibition(item.id)">
                            <div class="holding-item">
                                <div class="holding-img" v-if="item.main_img">
                                    <img :src="item.main_img && item.main_img.url" />
                                </div>
                                <div v-else class="blank-img">
                                    <img :src="logo" alt="">
                                </div>
                                <div class="holding-content">
                                    <div style="color:#333;font-size: 14px;line-height: 20px;margin: 15px 0px 10px 20px">
                                       <span>{{$t("exhibition").start_time}}：</span>
                                       <span>{{ (item.open_date).substring(0,10)}} ~ {{(item.close_date).substring(0,10)}}</span>
                                    </div>
                                    <div style="color:#333;font-size: 14px;line-height: 20px;margin: 0px 0px 10px 20px">
                                       <span>{{$t("exhibition").place}}：</span>
                                       <span>{{ item.base_info.exh_address || '/'}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </el-tab-pane> 
            </el-tabs>
        </el-drawer>
        <router-view ></router-view>
        <!--<a class="footer" href="https://beian.miit.gov.cn/">浙ICP备18054152号-2</a>-->
    </div>
</template>

<script>
import CHeader from "./components/Headers";
import CFooter from "./components/Footers"; 
import About from "./components/About";
import { mapState } from "vuex";
import api from "@/api";
import { setInterval } from 'timers';

export default {
    components: {
        CHeader,
        CFooter,
        About
    },
    computed: {
        ...mapState(["userInfo","language", "isLogin"]),
    },
    watch: {
        isLogin: {
            handler(newVal) {
                this.timer = window.setInterval(() => {
                    const daoIframe = this.$refs.iframe;
                    if(daoIframe) {
                        const token = localStorage.getItem('access_token')
                        if(token) {
                            daoIframe.contentWindow.postMessage({ token }, '*')
                        }else {
                            daoIframe.contentWindow.postMessage({ token: '' }, '*')
                        }
                        
                        clearInterval(this.timer)
                        this.timer = null
                    }
                },100)
            }
        }
    },
    filters: {
        isOpens(val) {
            return val ? "现已开放" : "暂未开放";
        }
    },
    created(){
        this.getOptionsPavilion()
        this.getIsHoldingExhibition()
        this.getEndExhibition()
        this.getTime()
        this.src = 'https://720.cloudvhall.com/shidai/island-xiugaihou/'
    },
    mounted() {
        setInterval(this.showMarquee, 2500)
        this.showAbout = false;
        this.showList = false;
        window.addEventListener("message",(res)=>{
            if(res.data == 'SD' ||  res.data == 'SD1' ||  res.data == 'SD2' ||  res.data == 'SD4') {
                this.handleHoldingDrawer()
            }
        });

        //浮岛跳舟展会处理
        const token = localStorage.getItem("access_token") || '';
        this.$refs.iframe.contentWindow.postMessage({ token }, '*')
    },
    beforeDestroy() {
      if (this.player) {
        this.player.dispose()
      }
    },
    data() {
        return {
            logo: require("../../../static//no-logo-new.png"),
            src:'',
            list: [],
            houldingDay: '2021-04-28 14:00',
            currentDay: '',
            // isVideoPop: false,
            loading: false,
            showAbout: true,
            hideMenu: false,
            showList: false,
            activeNum: -1,
            exhibitionName: '',
            drawerIsHolding: false,
            directionIsHolding: 'btt',
            activeNameIsHolding: 'first',
            holdingData: [],
            endData: [],
            imgShow: false,
            tradeImgShow: false,
            // player: null,
            isPavilion: false,
            start_time: '',
            end_time: '',
            isIE: true,
            timer: null
        };
    },
    methods: {
        goExhibition(_id){
            if(_id == '34'){
                this.$router.push({
                    path: '/area/zhanqu',
                    query:{
                        exhibition_id: _id,
                        status: '0',
                    }
                })
            }else{
                this.$router.push({
                    path: '/area/consult',
                    query:{
                        exhibition_id: _id,
                        status: '0',
                    }
                })
            }
            
        },
        goIsHolding(_id){
            if(_id == '34'){
                this.$router.push({
                    path: '/area/zhanqu',
                    query:{
                        exhibition_id: _id,
                        status: '0',
                    }
                })
            }else{
                this.$router.push({
                    path: '/area/consult',
                    query:{
                        exhibition_id: _id,
                        status: '0',
                    }
                })
            }
        },
        goLive(){
            var tempwindow=window.open('_blank')
            tempwindow.location = 'https://meeting.cloudvhall.com/'
            
        },
        goPavilion(_id, _status){
            this.$router.push({
               path: '/area/zhanqu',
               query:{
                   exhibition_id: _id,
                   status: _status,
               }
           })
        },
        getOptionsPavilion(){
            api.getExhibition({
                lasting: '1'
            }).then((res)=>{
                if(res.res == 1){
                    this.list = res.list
                }
            })
        },
        getIsHoldingExhibition(){
            api.getExhibition({
                lasting: '0',
                status: '2',
                // company_id: '582'
            }).then((res)=>{
                if(res.res == 1){
                    // console.log(res)
                    let newoption = []
                    res.list.forEach((item,index) => {
                        if(item.id == 21 || item.id == 34){
                            newoption.push(item)
                            this.holdingData = newoption
                            console.log(this.holdingData)
                        }
                    });
                }
            })
        },
        getEndExhibition(){
            api.getExhibition({
                lasting: '0',
                // status: '2'
            }).then((res)=>{
                if(res.res == 1){
                    let newoptionEnd = []
                    res.list.forEach((item,index) => {
                        // this.endData = res.list
                        if(item.id == 25 || item.id == 31 || item.id == 34){
                            newoptionEnd.push(item)
                            this.endData = newoptionEnd
                        }
                    });
                }
            })
        },
        handleCloseHolding(){
            this.drawerIsHolding = false
        },
        handleHoldingDrawer(){
            this.getIsHoldingExhibition()
            this.drawerIsHolding = true
        },
        handleChangeIsPavilion(){
            this.isPavilion = !this.isPavilion
        },
         handleClick(tab, event) {
            console.log(tab, event);
        },
        goPath(path, name) {
            if (path) {
                this.$store.state.currentExhibition = name;
                if (!this.userInfo.id) {
                    this.$router.push("/role");
                } else {
                  this.$router.push(path);
                }
            }
        },
        closeVideo() {
          this.isVideoPop = false
        },
        getTime() {
            var date = new Date();
            //以下代码依次是获取当前时间的年月日时分秒
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var minute = date.getMinutes();
            var hour = date.getHours();
            //固定时间格式
            if (hour >= 0 && hour <= 9) {
                hour = "0" + hour;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            if (month >= 0 && month <= 9) {
                month = "0" + month;
            }
            if (hour >= 0 && hour <= 9) {
                hour = "0" + hour;
            }
            if (minute >= 0 && minute <= 9) {
                minute = "0" + minute;
            }
            this.currentDay = year + "-" + month+ "-" + day + ' ' + hour+ ':' + minute
        },
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";
/deep/ .el-drawer__header{
    display: none;
    
}
/deep/ .el-tabs__active-bar{
    background-color: #0A468C
}
/deep/ .is-active{
    color: #0A468C;
}
/deep/ .el-tabs__header{
    margin: 30px 390px 20px 250px
}
/deep/ .el-tabs__content{
    margin: 30px 250px 20px 250px
}
/deep/ .el-drawer{
    height: 80% !important;
    box-shadow: 0px -10px 30px 0px rgba(6, 58, 120, 0.5);
}
/deep/ .el-tabs__item{
    font-size: 18px;
}
/deep/ .el-tabs__nav-wrap::after{
    width: unset;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  text-align: center;
  margin: 10px 0;
  color: #09468c!important;
}
.videoShow{
     position: fixed;
      top: 120px;
      left: 50%;
      transform: translateX(-90%);
      width: 35%;
      z-index: 1000;
      .video{
          width: 100%
      }
      .video-close{
           position: absolute;
          right: 10px;
          top: 10px;
          color: #fff;
          font-size: 14px;
          z-index: 100000;
      }
         
}
.exhibition-wrapper {
    min-width: 1400px;
    width: 100%;
    height: 100vh;
    // background: url("../../assets/exhibition/bg.png");
    background-size: 100%100%;
    position: relative;
    cursor: default;
    .edu-entry {
        position: fixed;
        top: 38%;
        left: 25%;
        width: 12%;
        height: 20%;
        cursor: pointer;
        img {
            position: absolute;
            left: -10px;
            top: -66px;
            cursor: pointer;
        }
    }
    .liveBox{
        padding: 10px;
        background: #fff;
        border-radius: 10px;
        opacity: 0.69;       
        position: fixed;  
        right: 5%; 
        top: 15%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .liveBox-img{
            width: 32px;
            height: 32px;
        }
        .liveBox-title{
            margin-top:8px;
            font-size: 16px;
            font-weight: 500;
            color: #115FD3;
            line-height: 22px;
        }
    }
    .show-pavilion{
        opacity: 0.7;
        position: absolute;
        width: 280px;
        height: 75px;
        top: 40%;
        left: 0;
        display: flex;
        align-items: center;
        z-index: 999;
        overflow: hidden;
        .show-pavilion-content{
            width: 280px;
            background: #ffffff;
            padding: 24px 24px 6px;
            overflow: hidden;
            .title{
                display: flex;
                align-items: center;
                overflow: hidden;
                .line{
                    width: 4px;
                    height: 20px;
                    background: #09468c;
                    margin-right: 4px;
                }
                .title-name{
                    font-size: 20px;
                    font-weight: 500;
                    color: #09468c;
                    line-height: 28px;
                    white-space: nowrap;
                }
            }
            .item{
                margin-top: 17px;
                .item-wrap{
                    margin-bottom: 18px;
                    cursor: pointer;
                    .item-name{
                        font-size: 14px;
                        text-align: left;
                        color: #333;
                        line-height: 22px;
                        font-weight: 400;
                        margin-bottom: 8px;
                    }
                    .item-time{
                        border: 1px solid #8390a8;
                        border-radius: 12px;
                        width: 99px;
                        height: 20px;    
                        font-size: 12px;   
                        color: #666;
                        line-height: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
        .hide-pavilion-content{
            display: flex;
            align-items: center;
            width: 20px;
            height: 75px;
            opacity: 0.7;
            background: #ffffff;
            border-radius: 0px 10px 10px 0px;
            cursor: pointer;
            .arrow-icon{
                color: #333;
            }
        }
    }
    .hide-pavilion{
        opacity: 0.7;
        position: absolute;
        top: 40%;
        left: 0;
        border-radius: 0px 10px 10px 0px;
        width: 20px;
        height: 75px;
        display: flex;
        background: #ffffff;
        align-items: center;
        cursor: pointer;
        .arrow-icon{
            color: #333;
        }
    }
    .holding-wrap{
        position: absolute;
        bottom: 60px;
        right: 3.5%;
        width: 420px;
        // height: 300px;
        // background: #FFFFFF;
        // border-radius: 40px;
        .holding-wrap-title{
            width: 420px;
            height: 80px;
            background: #194B96;
            border-radius: 40px 40px 0 0;
            display: flex;
            align-items: center;
            cursor: pointer;
            .holding-wrap-title-name{
                font-size: 24px;
                font-weight: 500;
                color: #FFFFFF;
                
            }
            .holding-wrap-title-img{
                margin-left: 45px;
                width: 34px;
                height: 29px;
                margin-right: 18px;
            }
        }
        .holding-wrap-content{
            width: 420px;
            height: 220px;
            background: #fff;
            border-radius: 0 0 40px 40px ;
            opacity: 0.7;
        }
    }
    .trade-entry {
        position: fixed;
        top: 48%;
        left: 45%;
        width: 20%;
        height: 20%;
        cursor: pointer;
        img {
            position: absolute;
            left: -10px;
            top: -66px;
            cursor: pointer;
        }
    }
    #videoPlay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
    }
    .cotentBox {
        // position: absolute;
        width: 100%;
        height: 100%;
        background-color: transparent;
        &-classify {
            min-width: 269px;
            height: 56px;
            background: #ffffff;
            border-radius: 16px;
            position: absolute;
            bottom: 45px;
            right: 38px;
            z-index: $zIndex-home-classify;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 41px;
            padding-right: 31px;
            .item {
                text-align: center;
                font-size: 13px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #09468c;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
                border-radius: 10px;
                cursor: pointer;
                img {
                    margin-right: 8px;
                    display: block;
                }
            }
            .active {
                background-color: #eee;
            }
            .yun {
                margin-right: 34px;
                img {
                    width: 24px;
                    height: 21px;
                }
            }
            .about {
                cursor: not-allowed;
                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .list {
            width: 501px;
            height: 450px;
            background: #ffffff;
            border-radius: 30px;
            position: absolute;
            right: 37px;
            bottom: 110px;
            z-index: $zIndex-home-classify;
            display: flex;
            flex-direction: column;
            align-items: center;
            box-sizing: border-box;
            padding-top: 18px;
            cursor: pointer;
            > li {
                width: 448px;
                height: 66px;
                background: #e6ecf3;
                border-radius: 22px;
                display: flex;
                align-items: center;
                margin: 2px 0;
                .imgWarpper {
                    width: 151px;
                    flex-shrink: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    .aImg {
                        width: 112px;
                        height: 46px;
                    }
                    .naImg {
                        width: 151px;
                        height: 35px;
                    }
                }
                .msgWarpper {
                    flex: 1;
                    height: 100%;
                    box-sizing: border-box;
                    padding-left: 20px;
                    padding-right: 30px;
                    display: flex;
                    align-items: flex-start;
                    justify-content: center;
                    flex-direction: column;
                    > p {
                        font-size: 13px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #09468c;
                        line-height: 18px;
                        .span2 {
                            margin-left: 10px;
                        }
                    }
                    .box {
                        width: 63px;
                        height: 18px;
                        line-height: 18px;
                        text-align: center;
                        background: #09468c;
                        border-radius: 8px;
                        font-size: 9px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #ffffff;
                        margin-top: 6px;
                    }
                }
            }
            .noactive {
                background: #e6ecf3;
                border-radius: 22px;
                .msgWarpper {
                    > p {
                        color: #bfbfbf;
                    }
                    .box {
                        background: #bfbfbf;
                    }
                }
            }
        }
    }
    .holding-item-wrap{
        cursor: pointer;
        // padding: 20px 6px;
        width: 30%;
        // height: 300px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 20px;
        border: 1px solid #C9C9D8;
        margin: 0px 30px 20px 0px;
        .holding-item{
            // width: 345px;
            // height: 300px;
            // border: 1px solid #c9c9d8;
            // border-radius: 20px;    
            .holding-img{
                // width: 345px;
                height: 220px;
                border-radius: 20px 20px 0 0;
                >img{
                    width: 100%;
                    height: 100%;
                    border-radius: 20px 20px 0 0;
                }
            }
            .blank-img{
                height: 220px;
                border-radius: 20px 20px 0 0;
                display: flex;
                justify-content: center;
                align-items: center;
                >img{
                    max-height: 220px;
                    object-fit: contain;
                }
            }
            // .holding-img{
            //     // width: 345px;
            //     height: 220px;
            //     border-radius: 20px 20px 0 0;
            //     display: flex;
            //     justify-content: center;
            //     align-items: center;
            //     >img{
            //         width: 100%;
            //         max-height: 220px;
            //         object-fit: contain;
            //         border-radius: 20px 20px 0 0;
            //     }
            // }
            .holding-content{
                // height: 100px;
            }
        }
    }
    .close-drawer{
        position: absolute;
        right: 15%;
        top: 5%;
        width: 25px;
        height: 25px;
        cursor: pointer;
    }
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
        
    }
    .carousel-name{
        // height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #49546B;
        line-height: 25px;
        margin: 25px 0 0 40px;
        width: 350px;
        word-break:break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .carousel-time{
        // width: 100px;
        width: 44%;
        height: 24px;
        border-radius: 12px;
        border: 1px solid #0A468C;
        color: #0A468C;
        line-height: 17px;
        font-size: 12px;
        margin: 18px 0 0 40px;
        // text-align: center;
        align-items: center;
        padding: 2px 0 0 18px;
    }
    // .el-carousel__item:nth-child(2n) {
    //     background-color: #99a9bf;
    // }
    
    // .el-carousel__item:nth-child(2n+1) {
    //     background-color: #d3dce6;
    // }
}
.pavilion-show-enter-active, .pavilion-show-leave-active {
  transition: width .5s;
}
.pavilion-show-enter, .pavilion-show-leave-to {
  width: 0!important;
}
.pavilion-hide-enter-active, .pavilion-hide-leave-active {
  transition: width .5s;
}
.pavilion-hide-enter, .pavilion-hide-leave-to {
  width: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/index.vue